// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowLeftCopper: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="currentColor">
            <polygon
                fill="currentColor"
                points="327.4 727 326 728.375 330.2 732.5 326 736.625 327.4 738 333 732.5"
                transform="matrix(-1 0 0 1 333 -727)"
            />
        </svg>
    );
};

export default React.memo(IconArrowLeftCopper);
